export const CHECK_UPDATE_GATEWAY_MODULE_TIME_INTERVAL = 30000;

export const DEFAULT_DELAY_SUCCESS_MESSAGE = 300;

export enum DELAY_MESSAGE_TIME {
  MEDIUM = 6,
  LONG = 10,
}
